import {
  Award_Points_Rounding_Strategy,
  AwardPointsInput,
  AwardVouchersInput,
  AwardPointsPerInput,
  AwardExternalPointsInput,
  AwardExternalInput,
  ExternalAwardProvider,
} from '@occc/graphql';

class AwardInputCreator {
  public createAwardPoints(points: number): { awardPoints: AwardPointsInput } {
    return {
      awardPoints: {
        points,
      },
    };
  }

  public createAwardVouchers(
    voucheredOfferId: string,
    options: { voucherExpirationDays?: number; voucherCount?: number } = {},
  ): { awardVouchers: AwardVouchersInput } {
    const { voucherExpirationDays, voucherCount = 1 } = options;

    return {
      awardVouchers: {
        voucherCount,
        voucheredOfferId,
        voucherExpirationDays,
      },
    };
  }

  public createAwardPointsPer(
    points: number,
    rounding: Award_Points_Rounding_Strategy,
  ): { awardPointsPer: AwardPointsPerInput } {
    return {
      awardPointsPer: {
        points,
        rounding,
      },
    };
  }

  public createAwardExternalPoints(maximum: number | undefined | null): {
    awardExternalPoints: AwardExternalPointsInput;
  } {
    return {
      awardExternalPoints: {
        maximum,
      },
    };
  }

  public createAwardExternal(provider: ExternalAwardProvider): {
    awardExternal: AwardExternalInput;
  } {
    return {
      awardExternal: {
        provider,
      },
    };
  }
}

export const awardInputCreator = new AwardInputCreator();
